"use client";

import Link from "next/link";
import { User as UserIcon } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { capitalize } from "@/lib/helper";

export default function BtnLogin() {
    const { user, isAuthenticated } = useAuth();

    const href = isAuthenticated
        ? process.env.NEXT_PUBLIC_URL_DASHBOARD || "http://localhost:3001"
        : "/auth/login";

    // info ممکنه رشته JSON یا آبجکت باشه
    const info =
        typeof user?.info === "string"
            ? (() => {
                try {
                    return JSON.parse(user.info as string);
                } catch {
                    return {};
                }
            })()
            : user?.info ?? {};

    const displayName = info?.name || capitalize(user?.username || "") || "کاربر";

    return (
        <div className="flex items-center gap-2">
            {isAuthenticated && (
                <span className="hidden text-sm text-gray-700 max-w-[120px] truncate">
                    {displayName}
                </span>
            )}
            <Link
                className={`ml-2 p-2 flex text-white rounded-lg ${isAuthenticated ? "bg-red-800" : "bg-blue-800"}`}
                aria-label="ورود به حساب کاربری"
                href={href}
            >
                <span className="hidden lg:block">
                    {isAuthenticated ? "ورود به داشبورد" : "ورود / ثبت‌نام"}
                </span>
                <UserIcon className="h-4 w-4 lg:mr-2 lg:mt-1" />
            </Link>
        </div>
    );
}